import { ChewyPaymentStepper } from '~/components/dashboard/invoices/payment/payment-details-dialog/chewy-payment/elements/ChewyPaymentsStepper/ChewyPaymentStepper'

import styles from './PaymentDialogV2Title.module.scss'

interface PaymentDialogV2TitleProps {
  activeStep?: number
  showStepper?: boolean
  title: string
}

const PaymentDialogV2Title = ({
  title,
  showStepper = false,
  activeStep = 1,
}: PaymentDialogV2TitleProps) => (
  <div className={styles.paymentDialogV2TitleContainer}>
    {title}
    {showStepper && (
      <div className={styles.stepperOverride}>
        <ChewyPaymentStepper activeStep={activeStep} />
      </div>
    )}
  </div>
)

export default PaymentDialogV2Title
